import { render } from "./ModalSearch.vue?vue&type=template&id=f8816ffe&lang=pug"
import script from "./ModalSearch.vue?vue&type=script&lang=js"
export * from "./ModalSearch.vue?vue&type=script&lang=js"

import "./ModalSearch.vue?vue&type=style&index=0&id=f8816ffe&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__